// import { logger } from '@/helpers';
import { defineComponent, onMounted, ref, computed, reactive } from 'vue'
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import platform from "platform";

import LogoSmall from "@/components/LogoSmall/LogoSmall.vue";
import ButtonGold from "@/components/ButtonGold/ButtonGold.vue";
// import PopupTerm from "@/components/PopupTerm/PopupTerm.vue";

import {  ApiService } from '@/api/api';


import { CardList} from "@/assets/data/card"

import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";



import { useGtag } from "vue-gtag-next";
// eslint-disable-next-line
import { gsap } from "gsap";

interface Carddetail {
  'cardid': string | undefined,
  'cardnumber': string | undefined,
  'name': string | undefined,
  'subtitle': string | undefined,
  'detail': string | undefined,
  'image'? : string | undefined
}

export default defineComponent({
  // type inference enabled

  components:{
    LogoSmall,
    ButtonGold,
    LottieAnimation
  },
  setup() {
    const { pageview,event } = useGtag();
    const btActive = ref(true);
    const IsGolden = ref(false);
    const router = useRouter();
    const store = useStore();
    const APIDownload =  process.env.VUE_APP_API_DOWNLOAD



    const IsIos =  () =>{
      if (platform.os?.family == 'iOS' || platform.os?.family == 'iPadOS'){
        return true;
      }else if(platform.os?.family =='OS X'){//
        return true;
      }else{
        return false
      }
     
    } 

    const Carddetail = reactive <Carddetail>({
      'cardid': '',
      'cardnumber':'',
      'name': '',
      'subtitle': '',
      'detail': '',
      'image':''
    })


    const CardData = computed(() => store.getters['Card/getCard'])


    const ShareFB =  async () =>{
      // eslint-disable-next-line
      (window as any).fbq('track', 'ShareFacebook') 
      if( IsGolden.value == true){
        event('click', { 'event_category' : 'share_fb', 'event_label': 'Golden'   })  
      }else{
        event('click', { 'event_category' : 'share_fb', 'event_label': 'normal'   })  
      }
      
      
      const ShareURL = `${process.env.VUE_APP_ShareURL}${CardData.value.cardid}.html`;
      const share_url = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(ShareURL);
      window.open(share_url, 'sharer', 'toolbar=0,status=0,width=650,height=400,resizable=yes');
      
      const RequestParam = {
        "activity": "consent",
      }
  
      await ApiService.SaveUserActivity(RequestParam)
    }

    const Luckydraw = async () =>{

      // let RequestData = {
          
      // }
      // let RequestResp = await ApiService.CheckStatus(RequestData)
      router.push('/Form')


    }





    

    onMounted( ()=>{
      pageview({ page_path: "/Result" });
    
      if(CardData.value.cardid == ''){
        router.push('/')
      }else{

        if (CardData.value.cardtype == 'Golden'){
          event('getcard', { 'event_category' : 'golden',    })
          // setTimeout(() => {
            IsGolden.value = true
          // }, 1000);
          
        }else{
          event('getcard', { 'event_category' : 'normal',    })
        }

        const CardId = CardData.value.cardid;

        const Detail = CardList.find(Card => Card.cardid == CardId);
       
        Carddetail.cardid = Detail?.cardid;
        Carddetail.cardnumber = Detail?.cardnumber;
        Carddetail.detail = Detail?.detail;
        Carddetail.name = Detail?.name;
        Carddetail.subtitle = Detail?.subtitle;
        Carddetail.image = Detail?.image;
        
        
      
       

        // gsap.fromTo('.card-title  ', { alpha: 0, scale: 0 }, { alpha: 1, scale: 1, delay: 0, duration: 1.2 })

        // gsap.fromTo('.Result_detail  ', { alpha: 0 }, { alpha: 1, scale: 1, delay: 0, duration: 2 })

        // gsap.fromTo('.card-shadow  ', { scale: 0,opacity:0 }, {  scale: 1,opacity:1, delay: 1, duration: 0.3 })

        setTimeout(() => {
          // document.getElementById('card')?.classList.add("flip")
          
         
        }, 200);
      }
      


    })

    return { btActive, IsGolden, Carddetail, ShareFB, Luckydraw, IsIos,platform,APIDownload}
  

  },
})
